<!DOCTYPE html>
<!--[if IE 9 ]>    <html class="ie9 ie"> <![endif]-->
<!--[if (gt IE 9)|!(IE)]><!-->
<html class="">
<!--<![endif]-->

 
<head>

    <meta http-equiv="content-type" content="text/html;charset=utf-8" />
    <meta charset="utf-8">
    <meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <link rel="canonical" href="index.html">
    <meta name="description" content="Let's Help ">
    <meta property="og:image" content="assets/Newcss/img/share-image.jpg" />
    <meta property="og:image:width" content="1536" />
    <meta property="og:image:height" content="768" />
    <meta property="og:url" content="index.html" />
    <meta property="og:title" content="Let's Help " />
    <meta property="og:site_name" content="Let's Help " />
    <meta property="og:description" content="Let's Help " />
    <meta name="google-site-verification" content="UmszyWVH-A9kg1qkMtAQgeW7q_MXxA2_2szNBNEN8Mo" />
    <link href='http://fonts.googleapis.com/css?family=Lato:400|Roboto+Slab:400,700' rel='stylesheet' type='text/css'>
    <link rel="apple-touch-icon" sizes="57x57" href="apple-touch-icon-57x57.png">
    <link rel="apple-touch-icon" sizes="60x60" href="apple-touch-icon-60x60.png">
    <link rel="apple-touch-icon" sizes="72x72" href="apple-touch-icon-72x72.png">
    <link rel="apple-touch-icon" sizes="76x76" href="apple-touch-icon-76x76.png">
    <link rel="apple-touch-icon" sizes="114x114" href="apple-touch-icon-114x114.png">
    <link rel="apple-touch-icon" sizes="120x120" href="apple-touch-icon-120x120.png">
    <link rel="apple-touch-icon" sizes="144x144" href="apple-touch-icon-144x144.png">
    <link rel="apple-touch-icon" sizes="152x152" href="apple-touch-icon-152x152.png">
    <link rel="apple-touch-icon" sizes="180x180" href="apple-touch-icon-180x180.png">
    <link rel="icon" type="image/png" href="favicon-32x32.png" sizes="32x32">
    <link rel="icon" type="image/png" href="android-chrome-192x192.png" sizes="192x192">
    <link rel="icon" type="image/png" href="favicon-96x96.png" sizes="96x96">
    <link rel="icon" type="image/png" href="favicon-16x16.png" sizes="16x16">
    <link rel="manifest" href="manifest.json">
    <meta name="msapplication-TileColor" content="#ca0000">
    <meta name="msapplication-TileImage" content="/mstile-144x144.png">
    <meta name="theme-color" content="#ffffff">
    <meta name="google-site-verification" content="zMbDS_-_Jn29SJhdwgRR5ynPmcVHsJHaxpmIHfIzF1U" />

</head>
<body>

    <div class="loader-bar"><div></div><div></div><div></div><div></div></div>


    <div id="page-wrapper">
        <header class="site-header">
            <div class="row">
                <div class="col-lg-6">
                    <span class="bg"></span><br>
                    <div class="row">
                        <div class="col-lg-3">
                            <a href="">
                                <img src="assets\img\Blood_DonationImages\LETS_HELP_LOGO.png" class="logo_all">
                            </a>
                        </div>
                        <div class="col-lg-5">
                            <!--<div class="logo_text">
                            <a href="">
                                <p class="logotext">LET'S HELP</p>
                                <sub>Together,For a Nobel Cause.</sub>
                            </a>
                        </div>-->
                        </div>
                        <div class="col-lg-2">
                            <button id="burger" class="hamburgwers" data-title="" routerLink="/Menu" style="float:right">
                                <span class="bars">
                                    <span class="bar bar1"></span>
                                    <span class="bar bar2"></span>
                                    <span class="bar bar3"></span>
                                </span>
                            </button>
                        </div>
                    </div>

                </div>

                <div class="col-lg-6"></div>
            </div>
        </header>


        <div id="page-content">
            <br />
            <div class="pane pane--left" data-pane="left" style="background-color: #4e4e48;">
                <div class="pane__inner allow-scroll" style="overflow:hidden">
                    <div class="section__content">
                        <div class="section__main section__main--standalone post post--single" style="padding-top: 50px;">
                        </div>
                        <div class="post-list__share share-job">
                            <br />  <br />


                            <div class="container">
                                <div class="row">

                                    <div class="col-lg-6">
                                        <div class="cards" [ngClass]="{ 'active': activeCardIndex === -1 }" (click)="handleClick(0)">
                                            <a routerLink="/Addtomember">
                                                <img src="../../../assets/Newcss/img/addamember.jpg" />
                                            </a>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="cards" [ngClass]="{ 'active': activeCardIndex === 1 }" (click)="handleClick(1)">
                                            <a routerLink="/Brochures">
                                                <img src="assets/Newcss/img/share.jpg">
                                            </a>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="cards" [ngClass]="{ 'active': activeCardIndex === 1 }" (click)="handleClick(2)">
                                            <img src="assets/Newcss/img/download.jpg" (click)="downloadlogo()">
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="cards" [ngClass]="{ 'active': activeCardIndex === 3 }" (click)="handleClick(3)">
                                            <a (click)="vol()">
                                                <img src="../../../assets/Newcss/img/joinasleader.png" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <!--<div class="pane pane--left" data-pane="left">
            <div class="pane__inner pane-header">

                <div class="bg-vid" data-src="dist/vid/Let's Help " style="background-image: url(assets/Newcss/img/PREREQ.jpg)"></div>
                <header class="pane-header__content">
                    <h2 class="page-title u-white" style="line-height: 60PX;">Donor Registration Form</h2>

                </header>

            </div>
        </div>-->

            <div class="pane pane--right" data-pane="right">
                <div class="pane__inner allow-scroll">

                    <div class="section__content">

                        <div class="section__main section__main--standalone post post--single">


                        </div>
                        <br /><br />
                        <h3 style="color:#000000">
                            <b>Donor Registration Form</b>
                        </h3>
                        <br />
                        <form class="form_1" [formGroup]="form" (ngSubmit)="Donersform()">

                            <div class="row">
                                <div class="col-lg-4" *ngIf="showFullNameInput">
                                    <label for="username">Full Name<span style="color:red">*</span></label>
                                </div>
                                <div class="col-lg-8" *ngIf="showFullNameInput">
                                    <input type="text" id="username" formControlName="username" placeholder="Donor Full Name" />
                                    <small style="color:red" class="text-danger" *ngIf="form.controls.username.touched && form.controls.username.errors?.required">Donor Name is required</small>
                                </div>
                                <div class="col-lg-8"></div>
                                <div class="col-lg-4">
                                </div>
                                
                                <div class="col-lg-4">
                                    <label for="mobile">Mobile Number<span style="color:red">*</span></label>
                                </div>

                                <div class="col-lg-8">
                                    <input type="text" formControlName="mobile" placeholder="Enter Your Mobile Number" id="mobile" name="mobile" inputmode="numeric" pattern="[0-9]*" maxlength="10" required oninput="this.value = this.value.replace(/[^0-9]/g, '');">

                                    <input *ngIf="showOTPInput && !showFullNameInput" type="text" formControlName="OTP" id="password" name="password" placeholder="Enter your OTP" maxlength="4" required (click)="checkOTP()">

                                    <button *ngIf="showLogin1 && !otpSent && !showOTPInput" class="btn btn-primary mb-3" type="button" (click)="CheckMobileNumber()" style="color:white">Send OTP</button>

                                    <button *ngIf="showOTPInput && !showFullNameInput" class="btn btn-primary mb-3" type="button" (click)="checkOTP()" style="color:white">Submit</button>


                                    <small style="color:red" class="text-danger" *ngIf="form.controls.mobile.touched && form.controls.mobile.errors?.required">Donor Mobile is required</small>
                                </div>


                                <div class="col-lg-8"></div>
                                <div class="col-lg-4">
                                </div>


                                <div class="col-lg-4" *ngIf="showFullNameInput">
                                    <label for="email">Email<span style="color:red">*</span></label>
                                </div>

                                <div class="col-lg-8" *ngIf="showFullNameInput">
                                    <input type="text" id="email" formControlName="email" placeholder="Email ID" />
                                    <small style="color:red" class="text-danger" *ngIf="form.controls.email.touched && form.controls.email.errors?.required">Donor Email is required</small>
                                </div>

                                <div class="col-lg-4" *ngIf="showFullNameInput">
                                    <label for="age">Gender<span style="color:red">*</span></label>
                                </div>
                                <div class="col-lg-8" *ngIf="showFullNameInput">
                                    <div class="row">
                                        <div class="col-lg-3 col-xs-6">
                                            <div class="chip1" (click)="selectGender('Male')" [ngClass]="{'selected': selectedGender === 'Male'}">Male</div>
                                        </div>
                                        <div class="col-lg-3 col-xs-6">
                                            <div class="chip1" (click)="selectGender('Female')" [ngClass]="{'selected': selectedGender === 'Female'}">Female</div>
                                        </div>

                                    </div>
                                </div>


                                <div class="col-lg-4" *ngIf="showFullNameInput">
                                    <label for="age">Ever donated blood<span style="color:red">*</span></label>
                                </div>
                                <div class="col-lg-8 mt-1 " *ngIf="showFullNameInput">
                                    <div class="row">
                                        <div class="col-lg-3 col-xs-6">
                                            <div class="chip1" (click)="PastDonation('Yes')" [ngClass]="{'selected': selectedpast === 'Yes'}">Yes</div>

                                        </div>
                                        <div class="col-lg-3 col-xs-6">
                                            <div class="chip1" (click)="PastDonation('No')" [ngClass]="{'selected': selectedpast === 'No'}">No</div>

                                        </div>
                                        <div class="col-lg-4 col-xs-6"></div>
                                    </div>

                                </div>
                                <div class="row" *ngIf="showFullNameInput">
                                    <div class="col-lg-4" *ngIf="selectedpast !== 'No'">
                                        <label>Last donate datee<span style="color:red">*</span></label>
                                    </div>
                                    <div class="col-lg-8 mt-1" *ngIf="selectedpast !== 'No'">
                                        <div class="input-group ml-2">
                                            <input style="height: 36px; margin-bottom: 8px;" class="form-control notnull txtDate" formControlName="Lastdonatedate" type="date" name="Lastdonatedate" id="Lastdonatedate" [(ngModel)]="selectedpast" [readonly]="selectedpast === 'No'">
                                        </div>

                                    </div>
                                </div>
                                <div class="col-lg-4" *ngIf="showFullNameInput">
                                    <label for="mobile">Weight<span style="color:red">*</span></label>
                                </div>

                                <div class="col-lg-8 mt-1" *ngIf="showFullNameInput">
                                    <input type="text" id="Weight" formControlName="Weight" placeholder="Weight " oninput="this.value = this.value.replace(/[^0-9]/g, '');" />
                                    <small style="color:red" class="text-danger" *ngIf="form.controls.Weight.touched && form.controls.Weight.errors?.required">Doner Weight is required</small>

                                </div>

                                <div class="col-lg-4" *ngIf="showFullNameInput">
                                    <label for="age">Age<span style="color:red">*</span></label>
                                </div>
                                <div class="col-lg-8" *ngIf="showFullNameInput">
                                    <input type="text" id="age" formControlName="age" placeholder="Age" oninput="this.value = this.value.replace(/[^0-9]/g, '');" />
                                </div>

                                <div class="col-lg-4" *ngIf="showFullNameInput">
                                    <label>Blood Group<span style="color:red">*</span></label>
                                </div>
                                <div class="col-lg-8 mt-n2" *ngIf="showFullNameInput">
                                    <div style="padding-left:0px">

                                        <p-autoComplete formControlName="bloodgroup" [suggestions]="deptList3" (completeMethod)="searchCont3($event)"
                                                        field="BLGName" [dropdown]="true" [size]="90"
                                                        placeholder="Search bloodgroup" [minLength]="1"
                                                        [style]="{'color': 'black'}"
                                                        [panelStyle]="{'background-color': 'white','margin-left':'3px','padding':'10px','box-shadow':' rgba(0, 0, 0, 0.24) 0px 3px 8px',}">
                                        </p-autoComplete>

                                        <small *ngIf="form.controls.bloodgroup.touched && form.controls.bloodgroup.errors?.required"
                                               class="p-error">blood group is required.</small>
                                    </div>
                                </div>
                            </div>

                        </form>


                        <form [formGroup]="form" (ngSubmit)="Donersform()">

                            <div class="row" *ngIf="showFullNameInput">

                                <div class="col-lg-4">
                                    <label>State Name<span style="color:red">*</span></label>
                                </div>
                                <div class="col-lg-8 mt-n2">

                                    <div style="padding-left:0px">

                                        <p-autoComplete formControlName="statename" [suggestions]="deptList" (completeMethod)="searchCont($event)"
                                                        field="StateName" [dropdown]="true" [size]="90" (click)="getDistrict()"
                                                        placeholder="Search State Name" [minLength]="1"
                                                        [style]="{'color': 'black'}"
                                                        [panelStyle]="{'background-color': 'white', 'box-shadow':' rgba(0, 0, 0, 0.24) 0px 3px 8px','margin-left':'3px','padding':'10px','cursor':'pointer',}"
                                                        required>

                                        </p-autoComplete>

                                        <small *ngIf="form.controls.statename.touched && form.controls.statename.errors?.required"
                                               class="p-error">State Name is required.</small>
                                    </div>

                                </div>

                                <div class="col-lg-4">
                                    <label>District Name<span style="color:red">*</span></label>
                                </div>
                                <div class="col-lg-8 mt-n2">

                                    <div style="padding-left:0px">

                                        <p-autoComplete formControlName="districtname" [suggestions]="deptList1" (completeMethod)="searchCont1($event)"
                                                        field="DistrictName" [dropdown]="true" [size]="90" (click)="getCity()"
                                                        placeholder="Search District Name" [minLength]="1"
                                                        [style]="{'color': 'black'}"
                                                        [panelStyle]="{'background-color': 'white', 'box-shadow':' rgba(0, 0, 0, 0.24) 0px 3px 8px','margin-left':'3px','padding':'10px'}" required>

                                        </p-autoComplete>

                                        <small *ngIf="form.controls.districtname.touched && form.controls.districtname.errors?.required"
                                               class="p-error">District Name is required.</small>
                                    </div>
                                </div>


                                <div class="col-lg-4">
                                    <label>City Name<span style="color:red">*</span></label>
                                </div>
                                <div class="col-lg-8 mt-n2">
                                    <div style="padding-left:0px">

                                        <p-autoComplete formControlName="cityname"
                                                        [suggestions]="deptList2"
                                                        (completeMethod)="searchCont2($event)"
                                                        field="CityName"
                                                        [dropdown]="true"
                                                        [size]="120"
                                                        placeholder="Search City Name"
                                                        [minLength]="1"
                                                        [style]="{'color': 'black'}"
                                                        [panelStyle]="{'background-color': 'white', 'box-shadow':' rgba(0, 0, 0, 0.24) 0px 3px 8px','margin-left':'3px','padding':'10px',}" required>
                                        </p-autoComplete>


                                        <small *ngIf="form.controls.cityname.touched && form.controls.cityname.errors?.required"
                                               class="p-error">City Name is required.</small>
                                    </div>

                                </div>


                                <div class="col-lg-4">
                                    <label for="useraddress">User Address</label>
                                </div>
                                <div class="col-lg-8">
                                    <!--<input type="text" class="form-control" [(ngModel)]="useraddress" (keydown.enter)="$event.preventDefault()" placeholder="Search Nearest Location" autocorrect="off" autocapitalize="off" spellcheck="off" type="text" #search>-->

                                    <input type="text" id="useraddress" formControlName="useraddress" placeholder="User Address" />
                                </div>

                                <div class="col-lg-4">
                                    <label for="area">Area<span style="color:red">*</span></label>
                                </div>
                                <div class="col-lg-8">
                                    <input type="text" id="area" formControlName="area" required placeholder="Area" />
                                </div>

                                <div class="col-lg-4">
                                    <label for="mobile">Pincode<span style="color:red">*</span></label>
                                </div>

                                <div class="col-lg-8">
                                    <input type="text" id="Pincode" formControlName="Pincode" placeholder="Pincode" maxlength="6" min="5" oninput="this.value = this.value.replace(/[^0-9]/g, '');" />
                                    <small style="color:red" class="text-danger" *ngIf="form.controls.Pincode.touched && form.controls.Pincode.errors?.required">Pincode is required</small>

                                </div>

                                <div class="col-lg-4">
                                    <label for="area">Message to blood Requester</label>
                                </div>
                                <div class="col-lg-8">
                                    <input type="text" id="Messagetorequester" formControlName="Messagetorequester" placeholder="Message to blood requester" />
                                </div>
                            </div>

                            <div class="row" *ngIf="showFullNameInput">
                                <div class="col-lg-3"></div>
                                <div class="col-lg-1 mt-2">
                                    <input type="checkbox" formControlName="termsAndConditions" style="display:inline;float:right;margin-left:8px;  " (change)="checkFormValidity()">
                                </div>
                                <div class="col-lg-8" (click)="openLoginModal1()">
                                    <div style="text-align: left; cursor: pointer;">I Agree to the terms and conditions of the website</div>
                                </div>

                                <div class="col-lg-3"></div>
                                <div class="col-lg-1 mt-2">
                                    <input type="checkbox" formControlName="eligibilityCriteria" style="display: inline; float: right; margin-left: 8px; " (change)="checkFormValidity()">
                                </div>
                                <div class="col-lg-8" (click)="openLoginModal()">
                                    <div style="text-align: left; cursor: pointer;">I Have read the eligibility criteria and confirm that I am eligible to Donate blood</div>
                                </div>
                            </div>
                            <br />
                            <div class="col-lg-4"></div>
                            <div class="col-lg-4" style="text-align: center; cursor: pointer;" *ngIf="showFullNameInput">
                                <!--<button class="btn">Submit</button>-->
                                <button type="submit" style="background-color: #1c60d9;" class="btn1" [disabled]="!form.valid">Submit</button>
                            </div>
                            <div class="col-lg-4"></div>
                        </form>

                    </div>
                </div>
            </div>




        </div>
    </div>
    <div class="modal" id="myModal">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header state modal-primary">
                    <h4 style="text-align:left;" class="modal-title" id="modal-primary-label">
                        Eligibility Criteria
                    </h4>

                    <button type="button" class="close" (click)="closeModal()" data-dismiss="modal" aria-label="Close"><span aria-hidden="true" style="color:black">X</span></button>
                </div>
                <div class="modal-body">
                    <div class="container">
                        <div class="card_1">
                            <div class="row">
                                <div class="col-lg-12">
                                    <fieldset>

                                        Eligibility Criteria to Donate Blood
                                        <br />

                                        There are several parameters that determine the eligibility of an individual to donate blood.
                                        <br />
                                        . Overall health- The donor must be fit and healthy, and should not be suffering from transmittable diseases.
                                        <br />
                                        . Age and weight- The donor must be 18–60 years old and should weigh a minimum of 50 kg.
                                        <br />
                                        . Pulse rate- Between 50 and 100 without irregularities.
                                        <br />
                                        . Hemoglobin level- A minimum of 12.5 g/dL.
                                        <br />. Blood pressure- Diastolic: 50–100 mm Hg, Systolic: 100–180 mm Hg.
                                        <br />. Body temperature- Should be normal, with an oral temperature not exceeding 37.5 °C.
                                        <br />. The time period between successive blood donations should be more than 3 months.
                                        <br />
                                        Individuals under certain conditions are deemed ineligible to donate blood
                                        <br />
                                        . A person who has been tested HIV positive.
                                        <br />. Individuals suffering from ailments like cardiac arrest, hypertension, blood pressure, cancer, epilepsy, kidney ailments and diabetes.
                                        <br />. A person who has undergone ear/body piercing or tattoo in the past 6 months.
                                        <br />. Individuals who have undergone immunization in the past 1 month.
                                        <br />. Individuals treated for rabies or received Hepatitis B vaccine in the past 6 months.
                                        <br />. A person who has consumed alcohol in the past 24 hours.
                                        <br />. Women who are pregnant or breastfeeding.
                                        <br />. Individuals who have undergone major dental procedures or general surgeries in the past 1 month.
                                        <br />. Women who have had miscarriage in the past 6 months.
                                        <br />. Individuals who have had fits, tuberculosis, asthma and allergic disorders in the past.
                                    </fieldset>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </div>

        </div>
    </div>

    <div class="modal" id="myModal1">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header state modal-primary">
                    <h4 style="text-align:left;" class="modal-title" id="modal-primary-label">
                        Terms and Conditions
                    </h4>

                    <button type="button" class="close" (click)="closeModal()" data-dismiss="modal" aria-label="Close"><span aria-hidden="true" style="color:black">X</span></button>
                </div>
                <div class="modal-body">
                    <div class="container">
                        <div class="card_1">
                            <div class="row">
                                <div class="col-lg-12">
                                    <fieldset>

                                        In using this Site, you agree to and understand these Terms of Use as well as our Privacy Policy. Lets- fignt website reserves the right to change the content within the web pages and within the Website Privacy Policy and Terms and Conditions at any time, without notice, at any time by updating this posting. You should visit this page periodically to review the current terms and conditions.
                                        <br />
                                        GENERAL DISCLAIMER:
                                        <br />
                                        Let's Help.com is a Non Profit, Non Commercial, ......
                                        <br />
                                        The information on this Site or otherwise communicated to users of this Site, including information communicated via e-mail is is provided solely for the Social cause and this site is Non Commercial, .
                                        We make reasonable efforts to present current and accurate information. We would not assume any legal liability and makes no representations or warranties concerning the accuracy, completeness, timeliness, reliability or usefulness of the materials accessed from or through this Site or any other site accessed through this Site. No warranty is made that the information provided is error- free. The numbers, percentages and ratios contained within the web pages may be, at any time, outdated and may include inaccuracies and/or errors.
                                        Let's Help assumes no responsibility or liability for any consequence resulting directly or indirectly from any action you take based on or made in reliance on the information or materials on this Site, or other sites linked to it. It does not represent or warrant that access to this Site or any sites linked to this Site will be uninterrupted, that this Site will operate error free. This Site or any portion thereof may be unavailable at any time
                                        <br />
                                        NOTIFICATION OF CHANGES:
                                        <br />
                                        We aim to update our site regularly, and may change the content at any time. If the need arises, we may suspend access to our site, or close it indefinitely. Any of the material on our site may be out of date at any given time, and we are under no obligation to update such material.
                                        <br />
                                        SECURITY
                                        <br />
                                        This website takes reasonable precautions to protect user information from unauthorized use or alteration. All data, correspondence, and responses that the user of the website provides will be handled confidentially, both online and offline.. Any Information Users submit via this website will not be shared nor rented, nor sold to others in any forms. All of our users’ personally identifiable information is restricted to our website only. However, the information that is needed for the Sole purpose of blood donation registration will be available for the public view. COPY RIGHT and TRADE MARKS All media (downloaded or samples), text, images, graphics, user interfaces, videos, photographs, and other content on the Site, including, but not limited to, the design, selection, arrangement, and coordination of such content on the Site, is not owned or licensed by or to Let's Help. Being a Social, Non commercial website, its been sourced through various forms from the Internet. We would like to thank all the News Channels in India, not limited to, English, Hindi or regional who has played a prominent part in building up this Website,we would like to thank Google, Wikipedia, Youtube and many more online informational sites that being a building block in making Let's Help and we assure you that none of the material will not be exploited for any commercial usage. You have been a part of our sincere endeavor of creating a good society and a social cause. If you still feel that your material, information should be deleted from this website, please feel free to send an email with the information to letsfight.ind&#64;gmail.com and we would delete it as soon as possible. REVIEWS, COMMENTS, COMMUNICATION and OTHER Site visitors may send communications; and submit suggestions, ideas, comments, questions, or other information, provided that the content is not illegal, obscene, threatening, defamatory, invasive of privacy or objectionable and does not consist of or contain software viruses, political campaigning, commercial solicitation, chain letters, mass mailings, or any form of “spam”. You may not use a false email address, impersonate any person or entity, or otherwise mislead as to the content’s origin. We have the right to disable any user identification code or password, whether chosen by you or allocated by us, at any time, if in our opinion you have failed to comply with any of the provisions of these terms of use. LINKS TO OTHER SITES This website may provide links or references to other sites. These links are provided for your convenience and Lets-help is not responsible for the content of these other sites, does not make any representations or gives any warranties with respect to any information contained in or at these other sites, and shall not be liable for any damages or injury arising from the content of these other sites.When leaving Lets-help website to visit another website, we recommend that you review that website’s terms and conditions and privacy policy. YOUR CONCERNS – TO CONTACT US If you have any questions concerning your right to the privacy and confidentiality of your personal information and data that has been entrusted to Lets-help.com website or for any specific inquiries, please contact us directly using our online contact us form Thank you for visiting our site.
                                        <br />
                                    </fieldset>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </div>

    </div>
    <!--</div>-->



</body>


</html>

<style>
    #active:checked + .menu-btn:hover:before {
        border-color: red;
    }

    #active:checked + .menu-btn:hover:after {
        border-color: red;
    }
    @media (min-width: 992px) {
        .allow-scroll .pane__content {
            height: 100%;
            overflow: auto;
            overflow-x: hidden;
        }
    }

    .wrapper {
        position: fixed;
        top: 0;
        right: -109%;
        height: 100%;
        width: 100%;
        background: black;
        transition: all 0.6s ease-in-out;
    }

    #active:checked ~ .wrapper {
        right: 0;
    }

    .menu-btn {
        position: absolute;
        z-index: 2;
        right: 20px;
        top: 20px;
        height: 50px;
        width: 50px;
        text-align: center;
        line-height: 50px;
        font-size: 20px;
        cursor: pointer;
        transition: all 0.3s ease-in-out;
        border: 2px solid white;
    }

    @media (min-width: 992px) {
        .col-lg-3 {
            -ms-flex: 0 0 25%;
            flex: 0 0 25%;
            max-width: 25%;
        }
    }

    .menu-btn span,
    .menu-btn:before,
    .menu-btn:after {
        content: "";
        position: absolute;
        top: calc(50% - 1px);
        left: 30%;
        width: 40%;
        border-bottom: 2px solid white;
        transition: transform .6s cubic-bezier(0.215, 0.61, 0.355, 1);
    }

    .menu-btn:before {
        transform: translateY(-8px);
    }

    .menu-btn:after {
        transform: translateY(8px);
    }

    .close {
        z-index: 1;
        width: 100%;
        height: 100%;
        pointer-events: none;
        transition: background .6s;
    }

    /* closing animation */
    #active:checked + .menu-btn span {
        transform: scaleX(0);
    }

    #active:checked + .menu-btn:before {
        transform: rotate(45deg);
        border-color: #fff;
    }

    #active:checked + .menu-btn:after {
        transform: rotate(-45deg);
        border-color: #fff;
    }

    input[type="checkbox"] {
        display: none;
    }

    .menu {
        text-align: center;
        padding-top: 100px; /* Adjust as needed */
    }

        .menu a {
            display: inline-block;
            margin: 0 10px; /* Adjust spacing between links */
            color: #fff;
            text-decoration: none;
            font-size: 20px;
        }


    .h2, h2 {
        font-size: 32px;
    }

    .bg-red--light {
        background-color: #e00000;
        height: 330px;
        width: 100%;
        padding: 0;
        margin: 0;
    }

    .bg-red--darker {
        background-color: #900;
        height: 330px;
        width: 100%;
        padding: 0;
        margin: 0;
    }

    .bg-red--light {
        background-color: red;
        position: relative;
        width: 100%;
        padding: 0;
        margin: 0;
        height: 330px;
    }



    .bg-red {
        background-color: #ca0000;
        height: 330px;
        width: 100%;
        padding: 0;
        margin: 0;
    }

    .bg-red--dark {
        background-color: #ae0000;
        height: 330px;
        width: 100%;
        padding: 0;
        margin: 0;
    }

    .cartdetails {
        width: 100%;
        height: 55%;
        margin-top: 56%;
        border-radius: 10px;
        border: 2px solid black;
        background-color: white;
        padding: 17px;
        color: black;
    }

    .label {
        display: inline-block;
        margin-top: 12px;
    }

    .para {
        font-size: 15px;
        text-align: left;
    }

    .col-lg-2 {
        flex: 0 0 auto;
        width: 16.66666667%;
        margin-left: 11%;
    }

    .menu-btn:hover span,
    .menu-btn:hover:before,
    .menu-btn:hover:after {
        border-bottom-color: red;
    }

    .menu-btn:hover {
        background-color: white;
    }

    }

    #active:checked:hover + .menu-btn:before:hover {
        transform: rotate(45deg);
        border-color: red;
    }

    #active:checked:hover + .menu-btn:after:hover {
        transform: rotate(-45deg);
        border-color: red;
    }
    @media (min-width: 576px) {
        .col-sm-6 {
            /* flex: 0 0 auto; */
            width: 50%;
        }
    }

    @media (min-width: 768px) {
        .col-md-3 {
            /*flex: 0 0 auto;*/
            width: 25%;
        }
    }
</style>
